'use strict';

angular.module('imagetrend.components')
    .directive('hlpFileUpload', ['Format', function (Format) {
        return {
            restrict: 'AE',
            scope: {
                fileUpload: '=',
                question: '=?',
                parameters: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                documentTypes: '=?',
                pdf: '=?',
                fromForm: '=?', // Do not require text fields when true

                //disabled
                isDisabled: '=?',

                //required
                isRequired: '=?',
                showRequired: '=?',
                requiredText: '@?',

                //label
                showLabel: '@?',
                showDescription: '=?',
                topLabel: '=?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?',
                showColon: '=?'
            },
            replace: true,
            transclude: true,
            templateUrl: 'templates/file-upload/file-upload.html',
            link: function (scope, elem, attrs, ctrl) {

                //attributes
                if (!attrs.name) { attrs.name = 'input'; }
                if (!attrs.id) { attrs.id = attrs.name; }

                //label
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.fromForm) { attrs.fromForm = false; } else { if (attrs.fromForm == true || attrs.fromForm == 'true') { attrs.fromForm = true; } else { attrs.fromForm = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }

                scope.requireTextFields = !attrs.fromForm ? attrs.isRequired : false;

                scope.$evalAsync(function () {
                    if (!attrs.requiredText) { scope.requiredText = 'Please upload a ' + Format.label((scope.label || scope.name)) }
                });

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            },
            controller: ['$scope', '$rootScope', '$uibModal', '$timeout', 'Documents', function ($scope, $rootScope, $uibModal, $timeout, Documents) {
                $scope.profilePictureFileName = null;
                $scope.userID = null;

                //Check the show_value field to see if the user already has a profile picture
                if ($scope.fileUpload && $scope.fileUpload.data_point_code == "profile_photo" && $scope.fileUpload.show_value != null) {
                    $scope.profilePictureFileName = $scope.fileUpload.show_value;
                    //Additional validation if the file is required and the user already has a profile picture
                    var validationTimeout = $timeout(function () {
                        if ($scope.innerForm !== undefined && $scope.isRequired) {
                            $scope.innerForm.file.$setValidity("required", true);
                        }
                    }, 0);
                    $scope.$on("$destroy", function () {
                        $timeout.cancel(validationTimeout);
                    });
                }
                if ($scope.question && $scope.question.parameters && $scope.question.parameters.user_id) {
                    $scope.userID = $scope.question.parameters.user_id;
                }

                $scope.openDocumentModal = function (fileUpload) {
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'templates/file-upload/file-upload-modal.html',
                        controller: 'FileUploadModalController',
                        resolve: {
                            file_content: function () {
                                return fileUpload.file_content;
                            },
                            file_upload_existing_docs: function () {
                                if ($scope.question) {
                                    return $scope.question.file_upload_existing_docs;
                                }
                                return false;
                            },
                            question_id: function () {
                                if ($scope.question) {
                                    return $scope.question.id;
                                }
                                return null;
                            },
                            parameters: function () {
                                return $scope.parameters;
                            }
                        }
                    }).result.then(function (upload) {
                        if (upload != null) {
                            if (upload.document_id != null) {
                                var isNewUpload = upload.is_new_upload === true;
                                Documents.getByID(upload.document_id).then(function (file) {
                                    fileUpload.file_name = file.file_name;
                                    fileUpload.document_name = file.name;
                                    fileUpload.document_id = file.id;
                                    fileUpload.document_code = file.code;
                                    fileUpload.document_type = file.document_type_id;
                                    fileUpload.document_description = file.description;
                                    fileUpload.document_locked = !isNewUpload;
                                    $scope.locked = !isNewUpload;
                                    fileUpload.file_updated = isNewUpload;
                                });
                            }
                            else {
                                fileUpload.file_content = upload.file_content;
                                fileUpload.file_name = upload.file_name;
                                fileUpload.file_updated = true;
                                fileUpload.document_id = null;
                                fileUpload.document_locked = false;
                                $scope.locked = false;
                            }
                        }
                    });
                }

                if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                    if ($rootScope.enterprise && $rootScope.enterprise.website) {
                        $scope.portalURL = $rootScope.enterprise.website;
                    }
                    else {
                        $scope.portalURL = $rootScope.portalURL;
                    }
                }
                else {
                    if ($rootScope.enterprise && $rootScope.enterprise.site_location) {
                        $scope.portalURL = $rootScope.enterprise.site_location;
                    }
                    else {
                        $scope.portalURL = $rootScope.internalURL;
                    }
                }

                if ($scope.question && $scope.question.answer) {
                    $scope.locked = $scope.question.answer.document_locked;
                }

                $scope.validate = function () {
                    if ($scope.question !== undefined && $scope.fileUpload !== undefined) {
                        $scope.question.answer.invalid = !isEmpty($scope.innerForm.file.$error);

                        if ($scope.isRequired && $scope.fileUpload.document_id == null && (isUndefined($scope.fileUpload.file_content) || $scope.fileUpload.file_content == null)) {
                            $scope.question.answer.invalid = true;

                            // Fix the form submission issue with profile photo uploaded from form for user with existing profile photo (Bug #246607)
                            if ($scope.fileUpload.data_point_code == "profile_photo" && ($scope.fileUpload.show_value != null || !isUndefined($scope.fileUpload.show_value))) {
                                $scope.question.answer.invalid = false;
                            }
                        }

                        // This needs more checking, because that innerForm.file.$error isn't enough - 
                        // if the name or description are required but empty, we still need a validation error message, not just if the file isn't there.
                        if ($scope.requireTextFields && ($scope.isRequired && ($scope.question.answer.document_name == null || ($scope.question.file_upload_description == true && $scope.question.answer.document_description == null)))) {
                            $scope.question.answer.invalid = true;
                        }
                    }
                }
            }]
        }
    }]);